import {
  Box, Drawer, Icon, IconName, Text,
} from '@usealloy/component-library';
import type { ReactNode } from 'react';
import { useRef } from 'react';

type SideviewPanelProps = {
  onClose: () => void;
  children: ReactNode;
  panelTitle: string;
  collapsedTabTooltip: string;
};

export const SideviewPanel = ({
  onClose,
  children,
  panelTitle,
  collapsedTabTooltip,
}: SideviewPanelProps) => {
  const drawerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={drawerRef}
      style={{
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <style>
        {`
          [data-dragging="true"] [data-testid="drawer-content"] {
            pointer-events: none !important;
          }
        `}
      </style>
      <Drawer
        show
        collapsible
        collapsedTabIcon={IconName.SidebarFlip}
        collapsedTabTooltip={collapsedTabTooltip}
        toggleDrawer={() => {
          onClose();
        }}
        title={(
          <Box
            gap={2}
            alignItems="center"
            style={{
              display: 'inline-flex',
              width: 'auto',
              whiteSpace: 'normal',
            }}
          >
            <Box
              style={{
                backgroundColor: 'var(--cl-purple-100)',
                color: 'var(--cl-purple-600)',
                padding: '2px 6px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: 600,
                width: 'fit-content',
                flexShrink: 0,
              }}
            >
              <Icon icon={IconName.Alloy} size="small" /> AI
            </Box>
            <Text size={4} weight={500} style={{ whiteSpace: 'nowrap' }}>
              {panelTitle}
            </Text>
            <Text size={1} style={{ color: 'var(--cl-gray-700)' }}>
              Generated by AI. Double-check for accuracy.
            </Text>
          </Box>
        )}
        placement="right"
        defaultSize={600}
        style={{ pointerEvents: 'auto' }}
        isResizable
      >
        {children}
      </Drawer>
    </div>
  );
};

